import { getAuth } from "../../contexts/authStore";
import { getAppsyncUrl } from "../authenticate";


export async function putRequest(scheduleId: string, requestId: string, requestType: string, requesterId: string, requesterName: string, dateTimeRequested: string, requestDetails: string, status: string, approverId?: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putRequest(scheduleId: ${JSON.stringify(scheduleId)}, requestId: ${JSON.stringify(requestId)}, requesterName: ${JSON.stringify(requesterName)}, requestType: ${JSON.stringify(requestType)}
                , requesterId: ${JSON.stringify(requesterId)}, dateTimeRequested: ${JSON.stringify(dateTimeRequested)}, requestDetails: ${JSON.stringify(requestDetails)}, status: ${JSON.stringify(status)}${approverId ? ", approverId: " + JSON.stringify(approverId) : ''})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putRequest)
            })
        })
    }
}

export async function putInviteRequest(scheduleId: string, requestId: string, requestType: string, requesterId: string, requesterName: string, dateTimeRequested: string, requestDetails: string, status: string, approverId?: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putInviteRequest(scheduleId: ${JSON.stringify(scheduleId)}, requestId: ${JSON.stringify(requestId)}, requesterName: ${JSON.stringify(requesterName)}, requestType: ${JSON.stringify(requestType)}
                , requesterId: ${JSON.stringify(requesterId)}, dateTimeRequested: ${JSON.stringify(dateTimeRequested)}, requestDetails: ${JSON.stringify(requestDetails)}, status: ${JSON.stringify(status)}${approverId ? ", approverId: " + JSON.stringify(approverId) : ''})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putInviteRequest)
            })
        })
    }
}

export async function putNotificationRequest(userId: string, scheduleId: string, notificationType: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putNotificationRequest(userId: ${JSON.stringify(userId)}, scheduleId: ${JSON.stringify(scheduleId)}, notificationType: ${JSON.stringify(notificationType)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putNotificationRequest)
            })
        })
    }
}

export async function getRequests(scheduleId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `query Query {
                getRequests(scheduleId: ${JSON.stringify(scheduleId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getRequests)
            })
        })
    }
}

export async function getInviteRequests(scheduleId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `query Query {
                getInviteRequests(scheduleId: ${JSON.stringify(scheduleId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getInviteRequests)
            })
        })
    }
}